import { LoadingIcon } from '@readcloud/component-library';
import { FC } from 'react';

export const Loading: FC = () => (
  <div className="vh-100 media justify-content-center align-items-center">
    <LoadingIcon loading={true} />
  </div>
);
